import * as React from 'react'

function SvgRightArrow(props, svgRef) {
  return (
    <svg viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M2.35 11.064a.966.966 0 01-.67.27.966.966 0 01-.672-.27.926.926 0 01-.282-.659.906.906 0 01.282-.658l3.324-3.403a.228.228 0 000-.306l-3.43-3.83A.914.914 0 01.994.896a.972.972 0 011.348.088l4.03 4.498c.19.206.296.473.296.75 0 .278-.106.546-.297.752l-4.02 4.08z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgRightArrow)
export default ForwardRef
